<template>
<div class="chapter">
<div class="inner_page">
<p class="PT" id="pt001"><a id="page_5"></a><a href="#/xhtml/contents#pt-001"><img alt="image" src="images/lf.jpg"/><span class="space05">Nature’s God<span class="space05"><img alt="image" src="images/rf.jpg"/></span></span></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part001.vue?5988c266